// @ts-nocheck
import * as React from 'react';
import RadioGroup from 'components/uielements/RadioGroup';
import { useOnClickOutside } from 'utils/customHooks';
import SorterWrapper from './Sorter.style';
import type { SorterProps, OptionsProps } from './Sorter.types';

const Options = ({
  isOpen,
  onClear,
  onChange,
  onSave,
  options,
}: OptionsProps): React.ReactElement<any> | null =>
  isOpen ? (
    <div className='sorter__options-section'>
      <RadioGroup options={options as any[]} onChange={onChange} />
      <div className='sorter__options-buttons'>
        <span
          className='sorter__clear-btn'
          onClick={onClear}
          onKeyPress={onClear}
          role='button'
          tabIndex='0'
        >
          Clear
        </span>
        <span
          className='sorter__save-btn'
          onClick={onSave}
          onKeyPress={onSave}
          role='button'
          tabIndex='0'
        >
          Save
        </span>
      </div>
    </div>
  ) : null;

const Sorter = ({ isLoading, name, onChange, onClear, onSave, options }: SorterProps) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const wrapperRef = React.useRef();

  const handleIsOpen = () => {
    if (!isLoading) {
      setIsOpen(!isOpen);
    }
  };

  const handleOnSave = () => {
    setIsOpen(false);
    onSave();
  };

  const handleOnClear = () => {
    setIsOpen(false);
    onClear();
  };

  useOnClickOutside(wrapperRef, () => setIsOpen(false));
  const disabledClass = isLoading ? 'disabled' : '';
  return (
    <SorterWrapper ref={wrapperRef}>
      <span
        className={`sorter__main-btn ${disabledClass}`}
        onClick={handleIsOpen}
        onKeyPress={handleIsOpen}
        role='button'
        tabIndex='0'
      >
        {name}
      </span>
      <Options
        isOpen={isOpen}
        onClear={handleOnClear}
        onChange={onChange}
        onSave={handleOnSave}
        options={options}
      />
    </SorterWrapper>
  );
};

export default Sorter;
